import { render } from "./SpaceTypeForm.vue?vue&type=template&id=2965533f"
import script from "./SpaceTypeForm.vue?vue&type=script&lang=js"
export * from "./SpaceTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__